export function initAuth(store) {
  return new Promise((resolve, reject) => {
    if (store.getters["user/isLoggedIn"] === true) {
      resolve();
      return;
    }
    let auth = JSON.parse(localStorage.getItem("auth"));

    if (auth === null) {
      resolve();
      return;
    }

    store.commit("user/auth", auth);
    store
      .dispatch("user/userinfo")
      .then(() => {
        resolve();
      })
      .catch((error) => {
        store.dispatch("user/logout");
        reject(error);
      });
  });
}
